(() => {
const caseNav = document.querySelector('.case-nav');
document.addEventListener('click', event => {
  if (caseNav && !caseNav.contains(event.target)) caseNav.open = false;
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && caseNav?.open) {
    caseNav.open = false;
    caseNav.querySelector('summary').focus();
  }
});
caseNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { caseNav.open = false; }));
})();
